import Vue from "vue";
import Vuex from "vuex";
import newOrgProject from "./modules/newOrgProject";
import newDistProject from "./modules/newDistProject";
import newWedProject from "./modules/newWedProject";
import newIndProject from "./modules/newIndProject";
import createPlugin from "logrocket-vuex";
import LogRocket from "logrocket";
const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

// one store for entire application
export default new Vuex.Store({
  modules: {
    newOrgProject: newOrgProject,
    newDistProject: newDistProject,
    newWedProject: newWedProject,
    newIndProject: newIndProject
  },
  plugins: [logrocketPlugin],
  strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index.js